<template>
    <div class="d-flex d-flex-center d-flex-items-center box-h">
        <div class="align-center c-color">
            <div>
                <a-icon type="disconnect" class="f-80" />
            </div>
            <div class="f-34 m-t-50">您访问的页面不存在</div>    
            <a-button type="primary" class="m-t-80 w-300 h-45" @click="jumpUp">返回上层</a-button>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            jumpUp(){
                this.$router.go(-1)
            }
        }
    }
</script>

<style lang="scss">
    .box-h{
        height:100vh;
    }
</style>